import { render, staticRenderFns } from "./SupplierUnAppliedAmountPieChart.vue?vue&type=template&id=2f4f41d4"
import script from "./SupplierUnAppliedAmountPieChart.vue?vue&type=script&lang=ts"
export * from "./SupplierUnAppliedAmountPieChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports